import axios from "axios";
import ResponseAlerts from "../functions/ResponseAlerts";

const BASE_CLIENT = "identity-service/identity/organizations";

const RESOURCES = {
	LIST_CLIENTS: BASE_CLIENT,

	LIST_CLIENTS_PAGINATED: (page, searchText, orderBy) =>
		`${BASE_CLIENT}/paginated?page=${page}&limit=8&searchBy=${searchText}&orderBy=${orderBy.collumnTitle}&orderDirection=${orderBy.orderDirection}`,

	GET_CLIENT: (clientId) => `${BASE_CLIENT}/${clientId}`,

	DELETE_CLIENT: (clientId) => `${BASE_CLIENT}/${clientId}`,
};

class ClientService {
	static async listClients() {
		try {
			return await axios.get(RESOURCES.LIST_CLIENTS);
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao listar clientes",
			});
			return error.response;
		}
	}

	static async getClient(clientId, signal = undefined) {
		try {
			return await axios.get(RESOURCES.GET_CLIENT(clientId), { signal });
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao buscar cliente",
			});
			return error.response;
		}
	}

	static async listClientsPaginated(
		page,
		searchText,
		orderBy,
		signal = undefined,
	) {
		try {
			return await axios.get(
				RESOURCES.LIST_CLIENTS_PAGINATED(
					page,
					searchText,
					orderBy,
				),
				{
					signal,
				},
			);
		} catch (error) {
			// Não trata cancelamento como erro
			if (axios.isCancel(error)) {
				return;
			}

			console.log(error);

			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao listar clientes",
			});

			return error.response;
		}
	}

	static async createClient(payload) {
		try {
			const response = await axios.post(BASE_CLIENT, payload);
			ResponseAlerts({
				response: response,
				successMessage: "Cliente cadastrado com sucesso",
			});
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response.data.message || "Erro ao cadastrar cliente",
			});
			return error.response;
		}
	}

	static async deleteClient(clientId) {
		try {
			const response = await axios.delete(RESOURCES.DELETE_CLIENT(clientId));
			ResponseAlerts({
				response: response,
				successMessage: "Cliente excluído com sucesso",
			});
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response.data.message || "Erro ao excluir cliente",
			});
			return error.response;
		}
	}

	static async updateClient(clientId, payload) {
		return await axios
			.put(`${BASE_CLIENT}/${clientId}`, payload)
			.then((response) => {
				ResponseAlerts({
					response: response,
					successMessage: "Cliente atualizado com sucesso",
				});
				return response;
			})
			.catch((error) => {
				console.log(error);
				ResponseAlerts({
					response: error.response,
					errorMessage: error.response.data.message || "Erro ao atualizar cliente",
				});
				return error.response;
			});
	}

	static async partialUpdateClient(clientId, payload) {
		return await axios
			.put(`${BASE_CLIENT}/partial/${clientId}`, payload)
			.then((response) => {
				ResponseAlerts({
					response: response,
					successMessage: "Cliente atualizado com sucesso",
				});
				return response;
			})
			.catch((error) => {
				console.log(error);
				ResponseAlerts({
					response: error.response,
					errorMessage: error.response.data.message || "Erro ao atualizar cliente",
				});
				return error.response;
			});
	}
}

export default ClientService;
